
export class PujaVidhi {
  PujaVidhiId: number;
  PujaVidhiName: string;
  VidhiDate: string;
  Cost: number;
}



// WEBPACK FOOTER //
// ./src/app/prasad-order/puja-vidhi.ts